<template>
    <div class="project-container">
        财务报告
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
        return {
        };
    },
    watch: {},
    computed: {},

    created() { },
    mounted() {

    },
    methods: {

    },
};
</script>
<style lang="scss" scoped></style>